export const saveToDB = ansType =>{
    let getAnswer = {};

    //get the shopping cart from local storage
    const storedAns = localStorage.getItem('answer');
    if(storedAns){
        getAnswer = JSON.parse(storedAns);
    }

    // add quantity
    const quantity = getAnswer[ansType];
    if(quantity){
        const newQuantity = quantity + 1;
        getAnswer[ansType] = newQuantity;
    }
    else{
        getAnswer[ansType] = 1;
    }
    localStorage.setItem('answer', JSON.stringify(getAnswer));
}